var _rect, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickCircleRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 83,
    height: 83,
    rx: 41.5,
    fill: "#EA6C6C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3916 50.6224C54.2028 51.3729 54.2028 52.6865 53.3916 53.4371C53.0172 53.8124 52.5179 54 52.0187 54C51.4571 54 50.9579 53.8124 50.5835 53.4371L44.0312 46.8694L37.4165 53.4371C37.0421 53.8124 36.5429 54 36.0437 54C35.4821 54 34.9828 53.8124 34.6084 53.4371C33.7972 52.6865 33.7972 51.3729 34.6084 50.6224L41.1607 43.9922L34.6084 37.4246C33.7972 36.674 33.7972 35.3604 34.6084 34.6099C35.3573 33.7967 36.6677 33.7967 37.4165 34.6099L44.0312 41.1775L50.5835 34.6099C51.3323 33.7967 52.6427 33.7967 53.3916 34.6099C54.2028 35.3604 54.2028 36.674 53.3916 37.4246L46.8393 44.0547L53.3916 50.6224Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 43.5,
    stroke: "#EA6C6C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleRed);
export default __webpack_public_path__ + "static/media/tick-circle-red.845a717c910276ca61c93893db9ac921.svg";
export { ForwardRef as ReactComponent };